import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Importamos useLocation
import SkillsGrid from '../components/SkillsGrid';
import CoursesGrid from '../components/CoursesGrid';
import Testimonials from '../components/Testimonials';
import './HomePage.css';
import heroImage from '../vista.png'; 


const HomePage = () => {
  const location = useLocation();

  // Lógica para detectar si venimos de un link con #ancla y hacer scroll
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        // Esperamos un poquito a que cargue la página y hacemos scroll suave
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="home-container">
      
      {/* HERO */}
      <header className="hero">
        <div className="hero-content">
          <h1>Despierta tu talento y conquista un nuevo nivel de conocimiento en <span className="text-gold">Geología</span>, <span className="text-blue">Minería</span> e <span className="text-green">IA</span></h1>
          <p className="hero-desc">
            Perfecciona tu forma de comprender el subsuelo y sus recursos en una formación que une Geología, Minería e Inteligencia Artificial. Domina Leapfrog, el modelamiento 3D, la interpretación de sondajes y el análisis minero con Python, guiado por especialistas apasionados por la ciencia de la Tierra. Avanza a tu ritmo con clases grabadas y refuerza tu aprendizaje con sesiones en vivo y una comunidad que fluye como un río subterráneo. Gemini y Google AI Studio serán tus aliados para interpretar datos, crear modelos y automatizar tu trabajo. Un viaje donde el conocimiento profundo se fusiona con la innovación para elevar tu talento.
          </p>

          {/* --- AQUÍ AGREGAMOS LA IMAGEN --- */}
          <div className="hero-image-container">
            <img src={heroImage} alt="Plataforma Bull Miner" className="hero-main-img" />
          </div>
          

          
        </div>
      </header>

      {/* SECCIÓN 1: HABILIDADES (GRATIS) */}
      <section className="skills-section">
        <h2>Revisa nuestros cursos gratis en tendencia</h2>
        <p className="section-subtitle">Cursos gratis y grabaciones de webinars pasados</p>
        <SkillsGrid />
      </section>

      {/* SECCIÓN 2: CURSOS DE ESPECIALIZACIÓN (PAGO) */}
      {/* --- AQUÍ AGREGAMOS EL ID "cursos-pro" --- */}
      <section 
        id="cursos-pro" 
        className="skills-section" 
        style={{backgroundColor: '#0d1117', borderTop: '1px solid #30363d'}}
      >
        <h2>Cursos de Especialización Profesional</h2>
        <p className="section-subtitle">Programas completos con certificación, proyectos y mentoría.</p>
        <CoursesGrid />
      </section>

      {/* TESTIMONIOS */}
      <section className="testimonials-section">
        <h2>QUÉ DICEN LOS ALUMNOS DE NOSOTROS</h2>
        <Testimonials />
      </section>

    </div>
  );
};

export default HomePage;